const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.8C7.78782 12.8 7.58434 12.7158 7.43431 12.5657L5.03431 10.1657C4.72189 9.85331 4.72189 9.34678 5.03431 9.03436C5.34673 8.72194 6.4 8.80005 6.4 8.80005L8 8.80005L9.6 8.80005C10 8.80005 10.6533 8.72194 10.9657 9.03436C11.2781 9.34678 11.2781 9.85332 10.9657 10.1657L8.56568 12.5657C8.41565 12.7158 8.21217 12.8 8 12.8Z",
    fill: "#718096",
    style: {
      fill: "#718096",
      fill: "color(display-p3 0.4431 0.5020 0.5882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.83431 7.20006C9.83431 7.20006 10.6533 7.27817 10.9657 6.96575C11.2781 6.65333 11.2781 6.1468 10.9657 5.83438L8.56568 3.43438C8.25326 3.12196 7.74673 3.12196 7.43431 3.43438L5.03431 5.83438C4.72189 6.1468 4.72189 6.65333 5.03431 6.96575C5.34673 7.27817 6 7.20006 6 7.20006L8 7.20006L9.83431 7.20006Z",
    fill: "#718096",
    style: {
      fill: "#718096",
      fill: "color(display-p3 0.4431 0.5020 0.5882)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownFilled);
export default __webpack_public_path__ + "static/media/chevron-down-filled.3943923620bb68f3bbdfb087513ac27f.svg";
export { ForwardRef as ReactComponent };